import request from "@/utils/request";
import { requestExcel } from "@/utils";

// 获取省市
export function findProvinceCity(id) {
  return request({
    url: `/org/findProvinceCity/${id}`,
    method: "get"
  });
}

// 列表 page,size,sDate-开始时间,eDate-结束时间,pullBlackReason-拉黑原因
export function blackUserPage(data) {
  return request({
    url: `/org/blackUser/page`,
    method: "post",
    data
  });
}
// 新增、修改 userIds,pullBlackReason-拉黑原因，数据字典id,pullBlackReasonText
export function blackUserAdd(data) {
  return request({
    url: `/org/blackUser/add`,
    method: "post",
    data
  });
}
// 移出入职黑名单 userIds
export function blackUserRemove(data) {
  return request({
    url: `/org/blackUser/remove`,
    method: "post",
    data
  });
}
// ]] 入职黑名单

// 员工列表 动态 按权限
export function findUserByLabelAndNum(data) {
  return request({
    url: `/org/findUserByLabelAndNum`,
    method: "post",
    data
  });
}
// 员工列表 动态 不按权限
export function findUserByLabelAndNumAndFrom(data) {
  return request({
    url: `/org/findUserByLabelAndNumAndFrom`,
    method: "post",
    data
  });
}

// 员工列表 动态
export function userPage(data) {
  return request({
    url: `/org/userPage`,
    method: "post",
    data
  });
}

// 员工列表 JYT
export function findUserByLabelAndNumJYT(data) {
  return request({
    url: `/sys/findUserByLabelAndNum`,
    method: "post",
    data
  });
}

// 员工列表 动态
export function findUserLike(data) {
  return request({
    url: `/org/findUserLike`,
    method: "post",
    data
  });
}

// 新增员工 基本信息
export function saveSysUser(data) {
  return request({
    url: `/org/saveSysUser`,
    method: "post",
    data
  });
}

// 新增员工 扩展信息
export function saveUserInformation(data) {
  return request({
    url: `/org/saveUserInformation`,
    method: "post",
    data
  });
}

// 删除员工
export function delSysUser(id) {
  return request({
    url: `/org/delSysUser/${id}`,
    method: "get"
  });
}

// 查找用户信息
export function findSysUser(id) {
  return request({
    url: `/org/findSysUser/${id}`,
    method: "get"
  });
}

// 查找用户信息 请假单
export function findSysUserQingjia(id, startDate, endDate) {
  return request({
    url: `/org/findSysUserQingjia/${id}/${startDate}/${endDate}`,
    method: "get"
  });
}

// 查找 原 用户信息
export function findOrgPost(id) {
  return request({
    url: `/org/findOrgPost/${id}`,
    method: "get"
  });
}

// 离职单据查询用户信息
export function findSysUserByLZ(data) {
  return request({
    url: `/org/findSysUserByLZ`,
    method: "post",
    data
  });
}

// 查找用户扩展信息
export function findUserInformation(id) {
  return request({
    url: `/org/findUserInformation/${id}`,
    method: "get"
  });
}

// 修改用户信息
export function upDateSysUser(data) {
  return request({
    url: `/org/upDateSysUser`,
    method: "post",
    data
  });
}
// 修改用户
export function upDateSysUserV2(data) {
  return request({
    url: `/org/upDateSysUser/v2`,
    method: "post",
    data
  });
}

// 修改用户 集团
export function upDateSysUserV3(data) {
  return request({
    url: `/org/upDateSysUser/v3`,
    method: "post",
    data
  });
}
// 修改员工 扩展信息
export function upDateSysUserInformation(data) {
  return request({
    url: `/org/upDateSysUserInformation`,
    method: "post",
    data
  });
}

// 【【 员工操作
// 员工转正 / 离职
export function saveStaffStateRecord(data) {
  return request({
    url: `/org/saveStaffStateRecord`,
    method: "post",
    data
  });
}

// 根据ID 获取岗位信息
export function findPostByPostId(postId, userId) {
  return request({
    url: `/org/findPostByPostId/${postId}/${userId}`,
    method: "get"
  });
}
// 提交调岗操作
export function updateUserPost(data) {
  return request({
    url: `/org/updateUserPost`,
    method: "post",
    data
  });
}

// 获取兼岗列表
export function findPostByUserId(id) {
  return request({
    url: `/org/findPostByUserId/${id}`,
    method: "get"
  });
}

// 新增兼岗
export function saveUserPost(data) {
  return request({
    url: `/org/saveUserPost`,
    method: "post",
    data
  });
}
// 取消兼岗
export function cancelUserPost(data) {
  return request({
    url: `/org/cancelUserPost`,
    method: "post",
    data
  });
}

// 社保管理
export function saveSecurity(data) {
  return request({
    url: `/org/saveSecurity`,
    method: "post",
    data
  });
}

//  根据部门查员工
export function findSysUserByBId(id) {
  return request({
    url: `/org/findSysUserByBId/${id}`,
    method: "get"
  });
}

// 获取职业生涯
export function findCRById(id) {
  return request({
    url: `/org/findCRById/${id}`,
    method: "get"
  });
}
// 】】 员工操作

// 【【 社保查询
//
export function findSecurityFamilyByDynamic(data) {
  return request({
    url: `/org/findSecurityFamilyByDynamic`,
    method: "post",
    data
  });
}

// 】】 社保查询

// << 报表管理
// 员工花名册
export function postInfoUserRoster(data) {
  return request({
    url: `/org/postInfo/userRoster`,
    method: "post",
    data
  });
}
// 导出
export function exportUserRoster(data) {
  return request({
    url: `/org/postInfo/exportUserRoster`,
    method: "post",
    data
  });
}
// 3 兼岗预警
// 列表
export function conPostWarning(data) {
  return request({
    url: `/org/conPostWarning`,
    method: "post",
    data
  });
}
// 详情
export function conPostWarningInfo(data) {
  return request({
    url: `/org/conPostWarningInfo`,
    method: "post",
    data
  });
}

// >> 报表管理

//  >> 雇主保险单
//获取表格信息
export function insurancePage(data) {
  return request({
    url: `/org/employers/insurance/page`,
    method: "post",
    data
  });
}
//新增表格信息
export function insurancePut(data) {
  return request({
    url: `/org/employers/insurance/put`,
    method: "post",
    data
  });
}
//重发
export function insuranceStartUp(id) {
  return request({
    url: `/org/employers/insurance/startUp/${id}`,
    method: "get",
  });
}
//删除
export function insuranceDel(data) {
  return request({
    url: `/org/employers/insurance/del/${data.id}`,
    method: "get",
    data
  });
}
//识别身份证
export function recognizeldIdCard(data) {
  return request({
    url: `/org/ocr/recognizeldIdCard?url=${data}`,
    method: "get",
    data
  });
}
//识别银行卡
export function recognizeldBankCard(data) {
  return request({
    url: `/org/ocr/recognizeldBankCard?url=${data}`,
    method: "get",
    data
  });
}
//处理
export function insuranceHandle(data) {
  return request({
    url: `/org/employers/insurance/handle`,
    method: "post",
    data
  });
}
//导出
export function insuranceExport(data) {
  return request({
    url: `/org/employers/insurance/export`,
    method: "post",
    data
  });
}
//表单指引
export function findOne(tableType,clientType){
  return request({
    url: `/process/operationGuide/findOne/${tableType}/${clientType}`,
    method: "get",
  });
}
// 导出
export function listBillExportDownload(data) {
  return request({
    url: `/org/listBillExportDownload`,
    method: "post",
    data
  });
}
// 删除单据
export function delBillExportDownload(id) {
  return request({
    url: `/org/delBillExportDownload/${id}`,
    method: "get"
  });
}
//导出
export function schedulingExport(data) {
  return request({
    url: `/ade/scheduling/export`,
    method: "post",
    data
  });
}
// 导出
export function listAdeExportDownload(data) {
  return request({
    url: `/ade/exportDownload/page`,
    method: "post",
    data
  });
}
// 删除单据
export function delAdeExportDownload(id) {
  return request({
    url: `/ade/exportDownload/del/${id}`,
    method: "get"
  });
}

// 修改银行卡信息
export function updateBankAccount(data) {
  return request({
    url: `/org/updateBankAccount`,
    method: "post",
    data
  });
}